/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectPaymentsController', ProjectPaymentsController);

    ProjectPaymentsController.$inject = ['entity', '$state', '$http', '$stateParams', 'DateUtils'];

    function ProjectPaymentsController(entity, $state, $http, $stateParams, DateUtils) {
        var vm = this;
        vm.project = entity;
        vm.type = $stateParams.type;

        vm.setType = setType;
        vm.dataExport = dataExport;
        vm.abs = abs;
        vm.transition = transition;
        vm.payments = [];
        vm.sumNegative = 0;
        vm.sumPositive = 0;
        vm.totalSum = 0;

        $http.get('api/board/projects/payments', {
            params: {
                projectId: entity.id,
                type: vm.type
            }
        }).then(function (response) {
            vm.payments = response.data;
            for (var index = 0; index < vm.payments.length; index++) {
                if (vm.payments[index].amount < 0) {
                    vm.sumNegative += vm.payments[index].amount;
                } else {
                    vm.sumPositive += vm.payments[index].amount;
                }
                vm.payments[index].date = DateUtils.convertLocalDateToServer(vm.payments[index].date);
            }
            vm.totalSum = vm.sumNegative + vm.sumPositive;
        });

        // could be replaced with vm.project.bookedPlaces but this way it gets refreshed every time (not only with project reload)
        $http.get('api/board/bookings/summary', {
            params: {
                projectID: entity.id
            }
        }).then(function (response) {
            vm.status = response.data;
            vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
            vm.freePlaces = vm.project.places - vm.validPlaces
        });

        function setType(type) {
            vm.type = type;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                id: $stateParams.id,
                type: vm.type
            });
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/projects/export/', {
                params: {
                    projectId: $stateParams.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            }).catch(function () {
                vm.isSaving = false;
            });
        }

        function abs(data) {
            return Math.abs(data);
        }
    }
})();
